import * as yup from 'yup';

export const SentNotificationSchema = yup.object({
  viewAll: yup.boolean().required(),
});
